import { render, staticRenderFns } from "./CustomWaiver.vue?vue&type=template&id=2381f972&"
import script from "./CustomWaiver.vue?vue&type=script&lang=js&"
export * from "./CustomWaiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports